import { useEffect, useState } from "react";
import { motion } from "framer-motion";

import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import { useTranslation } from "react-i18next";
import { formatTime, getToday } from "../../utils/getDay";
import { useDispatch } from "react-redux";
import { notice } from "../../redux/action/action";
import {
  startLoading,
  stopLoading,
} from "../../redux/action/loading/loadingAction";
import Record from "./components/Record";
import { formatNumber } from "../../utils/formatNumber";
import { capitalizeFirstLetter } from "../../replace_str_constant";
import DateSelect from "../../components/TimePicker/DateSelect";
import NotFound from "../../components/ProgressBlock/NotFound";
import LoadingBlock from "../../components/Loading/LoadingBlock";
import DetailWrapper from "../../components/detailWrapper";
import ButtonTab from "../../components/TabComponent/ButtonTab";
import { getTransactionRecord } from "../../api/getApi";
import LoadingBetRecord from "../../components/Loading/LoadingBetRecord";

const Transaction = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`transaction.${key}`);

  const TAB = [
    { label: i18n("deposit"), value: "deposit" },
    { label: i18n("withdraw"), value: "withdraw" },
    { label: i18n("transfer"), value: "tran" },
  ];

  const [tab, setTab] = useState(TAB[0].value);
  const [datePicker, setDatePicker] = useState({
    str_date: getToday(),
    end_date: getToday(),
  });
  const [cashRecord, setCashRecord] = useState([]);
  const [apiCalling, setApiCalling] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    setApiCalling(true);
    getTransactionRecord({
      action: tab,
      params: {
        str_date: datePicker.str_date,
        end_date: datePicker.end_date,
      },
    })
      .then((data) => {
        setCashRecord(data.data);
      })
      .catch((err) => {})
      .finally(() => {
        setApiCalling(false);
      });
  }, [tab, datePicker]);
  return (
    <DetailWrapper>
      <CloseDetailPage title={i18n("title")} />
      <section className="py-common-padding-y">
        <section className="flex items-center mb-[10px]">
          <ButtonTab TABS={TAB} setTab={setTab} tab={tab} />
        </section>
        <section className="p-[10px]">
          <section>
            <DateSelect setDatePicker={setDatePicker} />
          </section>
          <section>
            <LoadingBetRecord commonLoading={apiCalling}>
              {cashRecord.length == 0 ? (
                <NotFound />
              ) : (
                cashRecord.map((item, index) => {
                  const method = item.action; //方式
                  const date = item.createDate; //日期
                  const yearAndMonth = date.slice(0, 7); //年月
                  const point =
                    tab === "deposit" ? item.inpoint : item.outpoint; //金额
                  const lastBalace = item.balance; //目前余额
                  const status = item.state; //状态

                  return (
                    <>
                      {index === 0 ||
                      yearAndMonth !==
                        cashRecord[index - 1]?.createDate?.slice(0, 7) ? (
                        <p className="text-base-light-dark dark:text-base-light-white text-lg my-[10px] rounded-[5px] dark:bg-base-light-dark bg-base-light-white font-semibold px-common-padding-x">
                          {yearAndMonth}
                        </p>
                      ) : null}

                      <Record
                        single={index % 2 === 0}
                        key={index}
                        method={capitalizeFirstLetter(method)}
                        time={date}
                        amounts={formatNumber(point)}
                        lastBalance={formatNumber(lastBalace)}
                        status={status}
                        props={item}
                      />
                    </>
                  );
                })
              )}
            </LoadingBetRecord>
          </section>
        </section>
      </section>
    </DetailWrapper>
  );
};

export default Transaction;
